import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_camera from '@devices/settings/device_settings/networks_camera.js';
import app_setting_camera from '@devices/settings/device_settings/app_setting_camera.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';

export default {
	name: 'ShellyCamera',
	friendly_name: 'Camera',
	family: 'camera',
	isPM: false,
	modes: {
		camera: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				{
					title: 'camera_zones',
					components: [
						{
							title: 'camera_zones',
							component: 'camera_zones',
						},
					],
				},
				{
					title: 'camera_and_video',
					components: [
						{
							title: 'camera_motion_detection',
							component: 'camera_motion_detection',
						},
						{
							title: 'camera_live_streams',
							component: 'camera_streams',
						},
						{
							title: 'camera_video_adjustments',
							component: 'camera_video_adjustments',
						},
						{
							title: 'camera_image_adjustments',
							component: 'camera_image_adjustments',
						},
						{
							title: 'camera_night_vision',
							component: 'camera_night_vision',
						},
					],
				},
				{
					title: 'camera_audio',
					components: [
						{
							title: 'camera_audio',
							component: 'camera_audio',
						},
					],
				},
				{
					title: 'camera_storage',
					components: [
						{
							title: 'camera_storage',
							component: 'camera_storage',
						},
					],
				},
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				virtual_components,
				networks_camera,
				bluetooth_gen_2,
				app_setting_camera,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'status_led', component: 'camera_status_led' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
